import { FetchResult, gql, useMutation } from "@apollo/client";

import {
  CreateGraphicMutation,
  CreateGraphicMutationVariables,
} from "../../generated/gql/graphql";

const CREATE_GRAPHIC = gql`
  mutation CreateGraphic($input: CreateGraphicInput!) {
    createGraphic(input: $input) {
      ... on CreateGraphicSuccess {
        graphic {
          id
          name
          asset {
            url
          }
        }
      }
      ... on CreateGraphicError {
        message
      }
    }
  }
`;

export function useCreateGraphic(): (
  variables: CreateGraphicMutationVariables,
) => Promise<FetchResult<CreateGraphicMutation>> {
  const [createGraphic] = useMutation<
    CreateGraphicMutation,
    CreateGraphicMutationVariables
  >(CREATE_GRAPHIC);
  return (variables: CreateGraphicMutationVariables) =>
    createGraphic({ variables });
}
